import {useTranslation} from "react-i18next";
import st from "@/styles/VerifyAccount.module.scss"
import clsx from "clsx";
import CameraWarns from "@/ui/CameraWarns.tsx";
import DocumentReader from "@/components/kyc_scenario_elements/DocumentReader.tsx";
import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {DocType, LocalLanguage, SendDocType} from "@/types_and_interfaces/types.ts";
import ResetDocReader from "@/components/kyc_scenario_elements/ResetDocReader.tsx";
import useDocReader from "@/hooks/document_reader.ts";
import {CircularProgress} from "@mui/material";
import {isMobile} from "react-device-detect";
import CloseBtn from "@/ui/CloseButton.tsx";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import StatusMessage from "@/ui/StatusMessage.tsx";
import {useAtom} from "jotai/index";
import {profile} from "@/atoms/profile.ts";
// import ChevroneIcon from "@/svg/ChevronIocn.tsx";
// import CMS from "@/utils/cms.ts";
// import LazyImage from "@/ui/LazyImage.tsx";
// import ClickableBgOverlay from "@/ui/ClickableBgOverlay.tsx";
import Button from "@/ui/Button.tsx";
import useAuth from "@/hooks/auth.ts";
import KYCInstructions from "@/components/kyc_scenario_elements/KycInstructions.tsx";
import CMS from "@/utils/cms.ts";
import LazyImage from "@/ui/LazyImage.tsx";
import WarningCircleIcon from "@/svg/WarningCircleIcon.tsx";



interface Props {
    doc_type:DocType
}
const MainElement:React.FC<Props> = ({doc_type}) => {
    const [hasCamera, setHasCamera] = useState(null);
    const navigate = useNavigate()
    const {t} = useTranslation()
    const [show_starter_info, set_show_starter_info] = useState(true)
    const auth = useAuth()
    
    
    const checkCameraAvailability = () => {
        return new Promise((resolve) => {
            navigator.mediaDevices.getUserMedia({ video: true })
                .then(stream => {
                    stream.getTracks().forEach(track => track.stop()); // Stop the stream
                    resolve(true);
                })
                .catch(() => {
                    resolve(false);
                });
        });
    };
    
    useEffect(() => {
        
        if(!show_starter_info) {
            checkCameraAvailability().then((cameraAvailable:any) => {
                if(cameraAvailable){
                    const docReaderHandling = useDocReader()
                    docReaderHandling.inject_window(true, doc_type)
                }
    
                setHasCamera(cameraAvailable);
            });
        }
        
    }, [show_starter_info]);
    
    useEffect(() => {
        const handlePopState = () => {
            navigate(-2)
        };
        
        window.addEventListener('popstate', handlePopState);
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    return (
        <>
            <div className={st.head_controllers}>
                {/*{isMobile && (*/}
                {/*    <button*/}
                {/*        onClick={() => {*/}
                {/*            eventEmitter.emit(local_events.set_show_instr, true)*/}
                {/*        }}*/}
                {/*        className={st.show_instr}*/}
                {/*    >*/}
                {/*        {t("instructions")}*/}
                {/*    </button>*/}
                {/*)}*/}
                
                <CloseBtn
                    className={st.close_btn}
                    onClick={() => {
                        let bk = localStorage.getItem(CommonClass.local_storage_fields.back_url)
                        
                        if(bk) {
                            navigate(bk)
                        } else {
                            navigate(DashboardClass.dashboard_routes.Home)
                        }
                    }}
                />
            </div>
            
            {show_starter_info ? (
                <>
                
                
                    <div className={clsx(st.starter_inf, isMobile && st.starter_inf_mobile)}>
    
                        {isMobile ? (
                            <>
                                {/*<IDCardIcon />*/}
                                <strong>{t("doc_scan")}</strong>
                            </>
                        ) : (
                            <span className={st.inf}>
                                {t("kyc1_inf") + " "} {isMobile && t("show_document")}
                            </span>
    
                        )}
                        
                        {doc_type === "old" && (
                            <div className={st.verso_rule}>
                                <strong className={st.danger}>
                                    {t("important")}:
                                </strong>
                                
                                <p className={st.rule_text} dangerouslySetInnerHTML={{__html: t("scan_back_first")}} />
                            </div>
                        )}
    
                        <Button
                            onClick={async () => {
                                set_show_starter_info(false)
                                await auth.auth_ping()
                            }}
                            animated
                        >
                            <span>
                                {t("start")}
                            </span>
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    {hasCamera === null ? (
                        <div className={clsx(st.loading_container, isMobile && st.mobile)}>
                            <CircularProgress color={"success"}/>
                            
                        </div>
        
                    ) : hasCamera ? (
                        <>
                            <CameraComponent doc_type={doc_type}/>
                        </>
                        
                    ) :
                        <>
                            <CameraWarns/>
                        </>
                    }
                
                </>
            )}
            
            {show_starter_info && (
                <KYCInstructions />
            )}
            
        </>
    );
};

const KYCStepOne = () => {
    const [doc_type, set_doc_type] = useState<DocType>("")
    const [selected_doc_type, set_selected_doc_type] = useState<DocType>("")
    const {t,i18n} = useTranslation()
    const raw_data = CMS["confirm-identity"]
    const [user] = useAtom(profile)
    const data = CMS.langAwareFilter(raw_data, (i18n.language as LocalLanguage))
    const {new_doc_example, old_doc_example} = data
    const navigate = useNavigate()
    const doc_type_examples = [
        {
            className: clsx(st.switcher_item, st.doc_new),
            src: (Array.isArray(new_doc_example) && new_doc_example.length) ? CMS.getFilePath(new_doc_example[0].path) : "",
            label: t("id_card_doc_type_new"),
            type: "new" as DocType
        },
        {
            className: clsx(st.switcher_item, st.doc_old),
            src: (Array.isArray(old_doc_example) && old_doc_example.length) ?  CMS.getFilePath(old_doc_example[0].path) : "",
            label: t("id_card_doc_type_old"),
            type: "old" as DocType
        }
    ]
    const is_switcher = CommonClass.general_settings?.kyc?.regula?.is_old_identity_card_scenario_enabled || false
    // const is_switcher = true
    
    return (
        <div
            className={clsx(st.kyc_step_one, isMobile && st.mobile)}
        >

            {is_switcher ? (
                <>
                    {(selected_doc_type.length > 0) ?

                        <MainElement doc_type={selected_doc_type} />

                    : (

                        <div className={clsx(st.doc_type_switcher_main, isMobile && st.is_mobile)}>
                            {user?.kyc_general_status === "ProcessingFailed" && (
                                <p className={clsx(st.status_message, st.warning)}>
                                    <WarningCircleIcon/>
                                    {t("continue_kyc_process")}
                                </p>
                            )}

                            <div className={clsx(st.doc_type_switcher_head)}>

                                <strong>
                                    {t("pick_doc_type")}
                                </strong>
                                
                                {isMobile && (
                                    
                                    <CloseBtn
                                        className={st.close_btn}
                                        onClick={() => {
                                            let bk = localStorage.getItem(CommonClass.local_storage_fields.back_url)
                                            
                                            if (bk) {
                                                navigate(bk)
                                            } else {
                                                navigate(DashboardClass.dashboard_routes.Home)
                                            }
                                        }}
                                    />
                                )}
                            
                            
                            </div>
                            
                            
                            <div className={st.switcher_flex}>
                            
                            {doc_type_examples.map((ex, i) => {
                                const active = ex.type === doc_type
                                return (
                                    <div
                                        key={`doc_type_examples_${i}`}
                                        className={clsx(ex.className, active && st.active)}
                                        onClick={() => set_doc_type(ex.type)}
                                    >
                                        
                                        <div className={st.item_heading}>
                                            <strong>{ex.label}</strong>
                                            
                                            <div className={st.bullet} />
                                        </div>
                                        
                                        <LazyImage
                                            className={clsx(st.doc_type_img)}
                                            src={ex.src}
                                            alt="doc_img"
                                        />
                                    </div>
                                )
                            })}
                            
                                
                            </div>
                            
                            <Button
                                disabled={doc_type === ""}
                                onClick={() => set_selected_doc_type(doc_type)}
                            >
                                {t("continue")}
                            </Button>
                        </div>
                        )}
                </>
            ) : (
                <MainElement doc_type={""}/>
            )}
        
        
        </div>
    )
}

interface CameraComponentProps {
    doc_type: DocType
}
const CameraComponent:React.FC<CameraComponentProps> = ({doc_type}) => {
    const {t} = useTranslation()
    const [send_doc_status, set_send_doc_status] = useState<SendDocType>("")
    const [is_reader, set_is_reader] = useState<boolean>(false)
    const effect_ran = useRef<boolean>(false)
    const [user] = useAtom(profile)
    const is_phone = Boolean(typeof user?.phone === "string" && user.phone.length)
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    
    const doc_status_handler = (x:SendDocType) => {
        set_send_doc_status(x)
    }
    

    const component_renderer = () => {
        
        switch (send_doc_status) {
            case "":
                return <DocumentReader doc_type={doc_type} />
            
            case "processing":
                return <DocumentReader doc_type={doc_type} />

            case "timeout_doc_blured":
                return <ResetDocReader message={t("unidentified_doc")}/>

            case "timeout_no_doc":
                return <ResetDocReader  message={t("include_doc")}  />
            
            case "error":
                return <ResetDocReader message={t("error_message")} />
            
            case "init_error":
                return <ResetDocReader message={t("error_message")} />
            
            case "no_camera":
                return <CameraWarns />
            
            case "fatale_error":
                return <StatusMessage
                    is_phone={is_phone}
                    status={"danger"}
                    text={t("failed_kyc1")}
                />

        }
    }

    useEffect(() => {

        if(!effect_ran.current) {
            let interval = setInterval(() => {
                if(debug === "true") console.info("KYC inquire modal interval 2")
                if((window as any).RegulaDocumentSDK !== undefined) {
                    set_is_reader(true)
                    clearInterval(interval)
                }
            }, 500)
        }

        eventEmitter.on(CommonClass.CustomEvents.switch_doc_reader, doc_status_handler)

        return () => {
            effect_ran.current = true
        }

    }, []);

    return is_reader && (
        <div className={clsx(st.column_center, st.second_step)}>
            {component_renderer()}
            
        </div>
    )
}


export default KYCStepOne